"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query emailTicketHoldersHistory($eventId: String!) {
    emailTicketHoldersHistory(eventId: $eventId) {
      _id
      orgId
      eventId
      userId
      subject
      body
      recipients
      createdAt
      status
      errorMessage
      processedAt
    }
  }
`;
exports.default = query;
//# sourceMappingURL=emailHoldersHistory.js.map